<template>
  <section :class="$style.wrapper">
    <div :class="$style.header">
      <div :class="$style.title">{{ title }}</div>
      <div :class="$style.orderAmount">{{ getOrderAmount }}</div>
      <div :class="$style.tradeRate">
        <Loading :loading="quoteLoadTimer">
          {{ getTradeRate }}
        </Loading>
      </div>
    </div>

    <slot name="payment-list" />

    <!-- <div :class="$style.viewMoreWrapper">
      <div :class="$style.viewMoreContainer">
        <div :class="$style.viewMore" @click="handleViewMore">
          <span>{{ $t("View fees") }}</span>
          <icon-arrow
            :class="[isViewMore ? $style.iconArrowUp : $style.iconArrowDown]"
          />
        </div>
      </div>

      <div v-if="isViewMore">
        <div :class="$style.orderFee">
          <span :class="$style.title">
            {{ $t("Network fees") }}:
            <icon-error
              @mouseenter="isShowNetworkTips = true"
              @mouseleave="isShowNetworkTips = false"
              :class="$style.iconTips"
            />
          </span>
          <Loading :loading="quoteLoadTimer">
            <span :class="$style.fee">{{ getNetworkFee }}</span>
          </Loading>
          <div
            :class="$style.tipsContent"
            v-show="isShowNetworkTips"
            v-html="$t('trade_confirm_desc.network_fees')"
          />
        </div>
        <div :class="$style.orderFee">
          <span :class="$style.title">
            {{ $t("Processing fees") }}:
            <icon-error
              @mouseenter="isShowProcessingTips = true"
              @mouseleave="isShowProcessingTips = false"
              :class="$style.iconTips"
            />
          </span>
          <Loading :loading="quoteLoadTimer">
            <span :class="$style.fee">{{ getProcessingFee }}</span>
          </Loading>
          <div :class="$style.tipsContent" v-show="isShowProcessingTips">
            {{ $t("trade_confirm_desc.processing_fees") }}
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Loading from "@/components/ui/Loading";

export default {
  name: "OrderConfirmView",
  props: {},
  data() {
    return {
      isViewMore: false,
      isShowNetworkTips: false,
      isShowProcessingTips: false
    };
  },
  computed: {
    ...mapState([
      "tradeQuantity",
      "tradeSide",
      "tradePair",
      "currencyUnitList",
      "approxInfo",
      "quoteLoadTimer"
    ]),
    ...mapGetters({
      asset: "asset"
    }),
    title() {
      return `${this.tradeSide} ${this.tradePair}`;
    },
    getOrderAmount() {
      return `${this.currencyUnitList[this.asset]} ${this.tradeQuantity} `;
    },
    getTradeRate() {
      return `You get ${this.approxInfo?.quantity ?? ""} ${this.tradePair} @ ${
        this.currencyUnitList[this.asset]
      } ${this.approxInfo?.price ?? ""}`;
    }
  },
  components: {
    Loading
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style module lang="scss">
@import "~rfs/scss";

.wrapper {
  @include rfs(560px, max-width);

  margin: auto;
  .header {
    @include rfs(24px, margin-bottom);

    .title {
      @include rfs(18px);
      @include rfs(24px, margin-bottom);

      font-weight: bold;
      color: var(--legend-c-text);
    }

    .orderAmount {
      @include rfs(42px);

      font-weight: 300;
      color: var(--legend-c-text);
    }

    .tradeRate {
      @include rfs(14px);

      min-height: rfs-value(24px);
      color: var(--grey-cool);
    }
  }
}
</style>
